<div class="flex flex-col w-9/12 md:w-full shadow-lg py-7 bg-edu-white mx-auto md:mx-0 h-auto">
	<img src="./assets/icons/quotation-green.svg" class="h-8 w-8 ml-7" />

	<p class="body px-5 mt-2.5 mb-5 w-full max-w-lg">{{ content }}</p>

	<p class="title marker green w-max pl-10 pr-3 mb-3">{{ name }}</p>

	<p class="body border border-edu-primary-green px-10 py-2.5 w-11/12 break-words mx-auto">{{ description }}</p>
</div>
